import { BasePlugin } from '../base'
import mdcTheme from './mdc-theme.vue'

export { mdcTheme }

export default BasePlugin({
  mdcTheme
})
